<template>
    <v-container>
        <div id="vis-container">
            
            <svg class="svg-frame2" height="1200"></svg>
            <svg class="svg-frame" width="1000" height="300"></svg>
        </div>
    </v-container>
</template>

<script>

import * as d3Base from 'd3';
import * as d3Collection from 'd3-collection';
import _ from 'lodash';
import * as d3Dag from 'd3-dag';

export default {
    data() {
        return {
            env: null,
            colors: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
        }
    },
    mounted() {
        var arrayData =  
        [
            {
            "id": "C001",
            "description": "Appropriations and Staffing",
            "start": "1982-03-25",
            "finish": "2015-03-24",
            "group": "Domestic",
            "parentIds": [],
            },
            {
            "id": "C002",
            "description": "Appropriations, Staffing and Security",
            "start": "2015-03-25",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": ["C001"]
            },
            {
            "id": "C003",
            "description": "Elections and Qualifications",
            "start": "1901-06-06",
            "finish": "1903-09-02",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C004",
            "description": "Disputed Returns and Qualifications",
            "start": "1903-09-03",
            "finish": "1987-09-22",
            "group": "Domestic",
            "parentIds": ["C003"]
            },
            {
            "id": "C005",
            "description": "House",
            "start": "1901-06-06",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C006",
            "description": "Library",
            "start": "1901-06-06",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C007",
            "description": "Printing",
            "start": "1901-06-06",
            "finish": "1970-06-11",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C008",
            "description": "Publications",
            "start": "1970-06-12",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": ["C007"]
            },
            {
            "id": "C009",
            "description": "Standing Orders",
            "start": "1901-06-05",
            "finish": "1987-09-21",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C010",
            "description": "Procedure",
            "start": "1987-09-22",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": ["C009"]
            },
            {
            "id": "C011",
            "description": "Selection of Bills",
            "start": "1989-12-05",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C012",
            "description": "Senators’ Interests",
            "start": "1994-03-17",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C013",
            "description": "Privileges",
            "start": "1965-02-02",
            "finish": "2022-10-06",
            "group": "Domestic",
            "parentIds": []
            },
            {
            "id": "C014",
            "description": "Regulations and Ordinances",
            "start": "1932-03-11",
            "finish": "2019-12-03",
            "group": "Legislative scrutiny",
            "parentIds": []
            },
            {
            "id": "C015",
            "description": "Scrutiny of Bills",
            "start": "1981-11-19",
            "finish": "2022-10-06",
            "group": "Legislative scrutiny",
            "parentIds": []
            },
            {
            "id": "C016",
            "description": "Social Environment",
            "start": "1970-06-11",
            "finish": "1975-11-11",
            "group": "Legislative and General Purpose Standing",
            "parentIds": []
            },
            {
            "id": "C017",
            "description": "Health and Welfare",
            "start": "1970-06-11",
            "finish": "1975-11-11",
            "group": "Legislative and General Purpose Standing",
            "parentIds": []
            },
            {
            "id": "C018",
            "description": "Social Welfare",
            "start": "1976-03-02",
            "finish": "1987-06-05",
            "group": "Legislative and General Purpose Standing",
            "parentIds": ["C017"]
            },
            {
            "id": "C019",
            "description": "Community Affairs",
            "start": "1987-09-22",
            "finish": "1994-10-09",
            "group": "Legislative and General Purpose Standing",
            "parentIds": ["C018"]
            },
            {
            "id": "C020",
            "description": "Community Affairs",
            "start": "1994-10-10",
            "finish": "2006-09-10",
            "group": "Legislation",
            "parentIds": ["C019"]
            },
            {
            "id": "C021",
            "description": "Community Affairs",
            "start": "1994-10-10",
            "finish": "2006-09-10",
            "group": "References",
            "parentIds": ["C019"]
            },
            {
            "id": "C022",
            "description": "Community Affairs",
            "start": "2006-09-11",
            "finish": "2009-05-13",
            "group": "Legislative and General Purpose Standing",
            "parentIds": ["C020","C021"]
            },
            {
            "id": "C023",
            "description": "Community Affairs",
            "start": "2009-05-14",
            "finish": "2022-10-06",
            "group": "Legislation",
            "parentIds": ["C022"]
            },
            {
            "id": "C024",
            "description": "Community Affairs",
            "start": "2009-05-14",
            "finish": "2022-10-06",
            "group": "References",
            "parentIds": ["C022"]
            },
            {
            "id": "C025",
            "description": "Economics",
            "start": "1994-10-10",
            "finish": "2006-09-10",
            "group": "Legislation",
            "parentIds": []
            },
            {
            "id": "C026",
            "description": "Economics",
            "start": "1994-10-10",
            "finish": "2006-09-10",
            "group": "References",
            "parentIds": []
            },
            {
            "id": "C027",
            "description": "Economics",
            "start": "2006-09-11",
            "finish": "2009-05-13",
            "group": "Legislative and General Purpose Standing",
            "parentIds": ["C025","C026"]
            },
            {
            "id": "C028",
            "description": "Economics",
            "start": "2009-05-14",
            "finish": "2022-10-06",
            "group": "Legislation",
            "parentIds": ["C027"]
            },
            {
            "id": "C029",
            "description": "Economics",
            "start": "2009-05-14",
            "finish": "2022-10-06",
            "group": "References",
            "parentIds": ["C027"]
            }
        ];

        const data = arrayData;

        const d3 = Object.assign({}, d3Base, d3Dag);

        const dag = d3.dagStratify()(data);
        const nodeRadius = 20;
        const layout = d3
            .sugiyama() // base layout
            .layering(d3.layeringSimplex())//d3.layeringSimplex(), d3.layeringLongestPath(),d3.layeringCoffmanGraham()
            .decross(d3.decrossTwoLayer().order(d3.twolayerOpt()))//d3.decrossOpt(), d3.decrossTwoLayer().order(d3.twolayerGreedy().base(d3.twolayerAgg())), d3.decrossTwoLayer().order(d3.twolayerAgg()), d3.twolayerOpt()
            .coord(d3.coordGreedy())//d3.coordSimplex(), d3.coordQuad(), d3.coordGreedy(), d3.coordCenter()
            .nodeSize((node) => [(node ? 3.6 : 0.25) * nodeRadius, 3 * nodeRadius]); // set node size instead of constraining to fit

        const { width, height } = layout(dag);

        const svgSelection = d3.select("svg.svg-frame");
        svgSelection.attr("viewBox", [0, 0, width, height].join(" "));
        const defs = svgSelection.append("defs"); // For gradients

        const steps = dag.size();
        const interp = d3.interpolateRainbow;
        const colorMap = new Map();

        for (const [i, node] of dag.descendants().entries()) {
            colorMap.set(node.data.id, interp(i / steps));
        }

        // How to draw edges
        const line = d3
            .line()
            .curve(d3.curveMonotoneY)
            .x((d) => d.x)
            .y((d) => d.y);

        // Plot edges
        svgSelection.append("g")
            .selectAll("path")
            .data(dag.links())
            .enter()
            .append("path")
            .attr("d", ({ points }) => line(points))
            .attr("fill", "none")
            .attr("stroke-width", 3)
            .attr("stroke", ({ source, target }) => 
            {
                // encodeURIComponents for spaces, hope id doesn't have a `--` in it
                const gradId = encodeURIComponent(`${source.data.id}--${target.data.id}`);

                const grad = defs.append("linearGradient")
                    .attr("id", gradId)
                    .attr("gradientUnits", "userSpaceOnUse")
                    .attr("x1", source.x)
                    .attr("x2", target.x)
                    .attr("y1", source.y)
                    .attr("y2", target.y);

                grad.append("stop")
                    .attr("offset", "0%")
                    .attr("stop-color", colorMap.get(source.data.id));

                grad.append("stop")
                    .attr("offset", "100%")
                    .attr("stop-color", colorMap.get(target.data.id));

                return `url(#${gradId})`;
            });

        // Select nodes
        const nodes = svgSelection.append("g")
            .selectAll("g")
            .data(dag.descendants())
            .enter()
            .append("g")
            .attr("transform", ({ x, y }) => `translate(${x}, ${y})`);

        // Plot node circles
        nodes.append("circle")
            .attr("r", nodeRadius)
            .attr("fill", (n) => colorMap.get(n.data.id));

        const arrowSize = (nodeRadius * nodeRadius) / 5.0;
        const arrowLen = Math.sqrt((4 * arrowSize) / Math.sqrt(3));
        const arrow = d3.symbol().type(d3.symbolTriangle).size(arrowSize);

        svgSelection.append("g")
            .selectAll("path")
            .data(dag.links())
            .enter()
            .append("path")
            .attr("d", arrow)
            .attr("transform", ({ source, target, points }) => {
                const [end, start] = points.slice().reverse();
                // This sets the arrows the node radius (20) + a little bit (3) away from the node center, on the last line segment of the edge. This means that edges that only span ine level will work perfectly, but if the edge bends, this will be a little off.
                const dx = start.x - end.x;
                const dy = start.y - end.y;
                const scale = (nodeRadius * 1.15) / Math.sqrt(dx * dx + dy * dy);
                // This is the angle of the last line segment
                const angle = (Math.atan2(-dy, -dx) * 180) / Math.PI + 90;

                return `translate(${end.x + dx * scale}, ${end.y + dy * scale}) rotate(${angle})`;
            })
            .attr("fill", ({ target }) => colorMap[target.data.id])
            .attr("stroke", "white")
            .attr("stroke-width", 1.5)
            .attr("stroke-dasharray", `${arrowLen},${arrowLen}`);

        // Add text to nodes
        nodes.append("text")
            .text((d) => d.data.id)
            .attr("font-weight", "bold")
            .attr("font-family", "sans-serif")
            .attr("text-anchor", "middle")
            .attr("alignment-baseline", "middle")
            .attr("fill", "white");


        const nodeCapture = dag.descendants();
        const linkCapture = dag.links();

        const nodeGroups = _.chain(nodeCapture).groupBy(data => data.x).map((value, key) => ({ x: key, items: value.map(item => item.data.id) })).value();
        const dataWithX = data.map(data => {
            var match = nodeGroups.find(node => node.items.some(c => c === data.id)).x;
            data.line = match;
            return data;
        });

        console.log(dataWithX)

        const env = {width: 1600, height: 1600, maxHeight: 1600, lineMaxHeight: 16,
            maxLineHeight: 40,
            minLabelFont: 16,
            margin: { top: 26, right: 0, bottom: 30, left: 150 },
            groupBkgGradient: ['#FAFAFA', '#E0E0E0'],
            xScale: d3Base.scaleTime(),
            yScale: d3Base.scalePoint(),
            grpScale: d3Base.scaleOrdinal(),
            xGrid: d3Base.axisTop(),
            yAxis: d3Base.axisRight(),
            xAxis: d3Base.axisBottom(),
            grpAxis: d3Base.axisLeft(),
            category: "group",
            svg: null,
            graph: null,
            graphW: null,
            graphH: null,
            nLines: 0,
            minSegmentDuration: 0,
            transDuration: 700,
            structData: null,
            flatData: null,
            g: null,
            labels: [],
            border:1,
            lineHeight:0,
            xt:null,
            color:[],
            colorScale:null,
            clip:null,
            group: null
        };



        //store unchanged data
        env.structData = dataWithX;

        //create d3 svg with viewing bounds
        const elem = d3Base.select("svg.svg-frame2")
            .attr('class', 'timelines-chart')
            .attr("viewBox", [0, 0,1000, 1300])
            .style("overflow", "visible");

        //Set a much larger height and width for the internal svg
        env.svg = elem.append("svg")
            .attr("border", env.border)
            .attr("width", env.width)
            .attr("height", env.height);

        //perform initial zoom
        // env.svg.call(d3Base.zoom()
        //     .scaleExtent([0.5, 32])
        //     .on("zoom", this.redraw(d3Base.event, d3Base, env)));

        var borderPath = env.svg.append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("height", env.height)
            .attr("width", env.width)
            .style("fill", "none");
        
        var grad = env.svg.append('defs')
            .append('linearGradient')
            .attr('id', 'grad')
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('y1', '0%')
            .attr('y2', '100%');

    console.log(env)

        grad.selectAll('stop')
            .data(env.groupBkgGradient)
            .enter()
            .append('stop')
            .style('stop-color', function (d) { return d; })
            .attr('offset', function (d, i) {
                return 100 * (i / (env.groupBkgGradient.length - 1)) + '%';
            })

        env.svg.transition().duration(100).attr('width', env.width).attr('height', env.height);

        env.graph = env.svg.append('g')

        env.g = env.svg.append("g").attr("transform", "translate(" + env.margin.left + "," + env.margin.top + ")");

        env.g.append('rect').attr("class", "temp")

        this.$nextTick().then(() => {

            this.buildDomStructure(env);
            this.convertdata(env)
            this.parseData(env.structData, d3Base, env);
            this.renderAxises(d3Base, env);          
            console.log(env) 
            this.draw(false, d3Base, env);

            // env.clip = env.svg.append("clipPath")
            //     .attr("id", "clip")
            //     .append("rect")
            //     .attr("width", env.graphW)
            //     .attr("height", 2200);
        });
    },
    methods: {
        buildDomStructure(env) {

            env.graphW = env.width - env.margin.left - env.margin.right;

            env.xScale.range([0, env.graphW])

            env.svg.attr("width", env.width);

            var axises = env.svg.append('g');

            env.graph.attr("transform", "translate(" + env.margin.left + "," + env.margin.top + ")");

            env.g.attr("transform", "translate(" + env.margin.left + "," + env.margin.top + ")");

            axises.attr("class", "axises")
                .attr("transform", "translate(" + env.margin.left + "," + env.margin.top + ")");

            axises.append("g")
                .attr("class", "x-axis");

            axises.append("g")
                .attr("class", "x-grid");

            axises.append("g")
                .attr("class", "y-axis")
                .attr("transform", "translate(" + env.graphW + ", 0)");

            axises.append("g")
                .attr("class", "grp-axis");

            env.xAxis.scale(env.xScale)
                .ticks(Math.round(env.graphW * 0.011));

            env.xGrid.scale(env.xScale)
                .tickFormat("")
                .ticks(env.xAxis.ticks()[0]);

            env.yAxis.scale(env.yScale)
                .tickSize(0);

            env.grpAxis.scale(env.grpScale)
                .tickSize(0);

        },
        convertdata(env) {
            for (var t = 0; t < env.structData.length; t++) {
                env.structData[t].start = new Date(env.structData[t].start)
                env.structData[t].finish = new Date(env.structData[t].finish)
                // env.structData[t].id = env.structData[t].id
                // env.structData[t].prevLink = env.structData[t].prevLink
            }
        },
        getColor(env) {           
            env.structData.forEach(function (item) {
                env.color.push(item.label)
            })
            env.color = env.color.filter((v, i, a) => a.indexOf(v) === i);
            return env.color
        },
        getlabels(env) {            
            env.labels= [];
            env.structData.forEach(function (item) {
                env.labels.push(item.sub)
            })
            env.labels = env.labels.filter((v, i, a) => a.indexOf(v) === i);
            env.labels.sort()
            return env.labels
        },
        getLines(env) {
            env.nLines = 0
            env.flatData.forEach(function (item) {
                env.nLines += item.count
            })
            return env.nLines
        },
        renderAxises(d3, env) {
            env.height = env.graphH + env.margin.top + env.margin.bottom
          
            env.svg.transition().duration(100).attr('width', env.width).attr('height', env.height);

            env.g.attr("transform", "translate(" + env.margin.left + "," + env.margin.top + ")");

            var fontVerticalMargin = 0.6;

            var fontSize = Math.min(12, env.graphH / env.flatData.length * fontVerticalMargin * Math.sqrt(2));
                  
            env.yScale            
                .domain(env.labels)
                .range([env.graphH / env.labels.length * 0.5, env.graphH * (1 - 0.5 / env.labels.length)]);

            //env.yScale.invert = invertOrdinal;
            //env.grpScale.invert = invertOrdinal;

            env.xGrid
                .scale(env.xScale)
                .tickSize(env.graphH)
                .tickFormat(d3.timeFormat("%b %Y"));
          
            env.xScale
                .domain([d3.min(env.structData, function (d) { return d.start; }), d3.max(env.structData, function (d) { return d.finish; })])
                .range([0, env.graphW]);


            env.svg.select('g.x-grid')
                .attr('transform', 'translate(0,' + env.graphH + ')')
                .transition().duration(100)
                .call(env.xGrid);


            var groups = env.graph.selectAll('rect.series-group, g.series-group ').data(env.flatData, function (d) {
                return d.category;
            });

            env.yAxis.tickValues("");   //labels

            env.svg.select('g.y-axis')
                .transition().duration(100)
                .attr('transform', 'translate(' + env.graphW + ', 0)')
                .style('font-size', fontSize + 'px')
                .call(env.yAxis);

            var minHeight = d3.min(env.grpScale.range(), function (d, i) {
                return i > 0 ? d - env.grpScale.range()[i - 1] : d * 2;
            });

            env.grpAxis.tickFormat(function (d) { return d })
                .ticks(0);

            env.grpScale.domain(env.flatData.map(function (d) {
                return d.category
            }));

            var cntLines = 0;
            env.grpScale.range(env.flatData.map(function (d) {
                var pos = (cntLines + d.count / 2) / env.nLines * env.graphH;
                cntLines += d.count;
                return pos;
            }));

            env.svg.select('g.grp-axis')
                .transition()
                .duration(100)
                .style('font-size', fontSize + 'px')
                .call(env.grpAxis);

            groups.exit().transition().duration(500).style('stroke-opacity', 0).style('fill-opacity', 0).remove();

            var newGroups = groups.enter()
                .append('rect')
                .attr('class', 'series-group')
                .attr('x', 0)
                .attr('y', 0)
                .attr('height', 0)
                .style('fill', 'url(#grad)');

            newGroups.append('title').text('click-drag to pan or mouse wheel to zoom in/out');

            groups = groups.merge(newGroups);

            groups.transition().duration(500)
                .attr('width', env.graphW)
                .attr('height', function (d) { return env.graphH * d.count / env.nLines; })
                .attr('y', function (d) { return env.grpScale(d.category) - env.graphH * d.count / env.nLines / 2; })
        },
        parseData(data, d3, env) {            
            this.convertdata(env)
            this.resolveOverlaps(d3, env)
            for (var t = 0; t < env.structData.length; t++) {
                env.structData[t].order = t + 1
            }
   
            env.structData.sort(function (a, b) {
                return d3.ascending(a.order, b.order);
            });

            env.labels = this.getlabels(env)
            env.nLines = this.getLines(env);
            env.graphW = env.width - env.margin.left - env.margin.right;
            env.graphH = d3.min([env.nLines * env.maxLineHeight, env.maxHeight - env.margin.top - env.margin.bottom]);
            env.g.attr("clip-path", "url(#clip)");
        },
        resolveOverlaps(d3, env) {
            for (var t = 0; t < env.structData.length; t++) {
                //env.structData[t].line = null  
                env.structData[t].sub = null  

            }

            env.flatData = []

            env.structData.sort(function (a, b) {
                return d3.ascending(a.start, b.start);
            });

            var keys = env.structData.map(function (d) { return d[env.category]; })
                .reduce(function (p, v) { return p.indexOf(v) == -1 ? p.concat(v) : p; }, [])
                .filter(function (d) { return (typeof d !== "undefined") ? d !== null : false });

            keys.forEach(function (key) {
                var items = env.structData.filter(function (d) { return d[env.category] === key; });
                var i, line, count = [], lines = [];

                var top = d3.max(env.structData, function (d) { return d.line }) || 0;        
              
                items.forEach(function (item) {                  
                    for (i = 0, line = 0; i < top; i++ , line++) {  
                   
                        if (item.finish <= lines[i]) { break; }
                    }
               
                    //item.line = item.line;           
                    item.sub = item[env.category] + '+&+' + item.line
                    lines[line] = item.start;
                    count.push(item.line);
                })
          
                env.flatData.push({ category: items[0][env.category], count: count.length })
            });
           
            env.flatData.sort(function (a, b) {
                return d3.ascending(a.category, b.category);
            });
        },
        update_group(env){
            var test = [];
            env.group = env.g.selectAll(".rectangle")
                .data(env.structData)
                .join(function (group) {
                    var outerG = group.append("g");
                    var rectItem = outerG.attr("class", "rectangle");
                    
                    group.each(function(d,i) { 
                    
                        d.parentIds.forEach(function (linkId) {
                            test.push("p-" + d.id + "-"+ linkId);
                        });
                    })

                    var denter = rectItem.append("svg").attr("class", function (d) { return "svgholder " + d.id; });
                    denter.append("rect").attr("class", function (d) { 
                        return "rectband " + d.id; 
                    });
                    denter.append("text").attr("class", function (d) { return "interval " + d.id; });
                    denter.append("rect").attr("class", function (d) { return "lefthand clasl " + d.id; });
                    denter.append("rect").attr("class", function (d) { return "righthand clasr " + d.id; });
                    
                    return denter;                     
                },
            );
            
            test.forEach(function (link) {
                env.g.append("path").attr("class", "path").attr("pathId", link).attr("d", "").attr("marker-end",    "").attr("stroke", "").attr("fill", "");
            });
            
            return env.group;
        },
        draw(event, d3, env) {                                          
           console.log(env)
           if (event) {
                var t = event.transform
                env.xt = t.rescaleX(env.xScale);
            } else {
                env.xt = env.xScale;
            }
        
            env.color = this.getColor(env)
            env.colorScale = d3.scaleOrdinal(this.colors).domain(env.color)
            env.lineHeight = env.graphH / env.nLines * 0.8;

            env.svg.select('.x-grid').call(env.xGrid.scale(env.xt));   
            const tr = env.svg.transition()
                .duration(750);
            this.update_group(env)


            env.g.selectAll(".rectangle")
                .attr("width", function (d) { 
             // console.log(d)
              return env.xt(d.finish) - env.xt(d.start) })
                .attr("height", env.lineHeight)
                .attr("fill", function (d, i) { return env.colorScale(d.description); })               
                .attr("transform", function (d) {
                   // console.log(d)
                    return "translate(" + env.xt(d.start) + "," + (d.line - env.lineHeight / 2) + ")";
                })
                .attr("xC", function (d) { return env.xt(d.start); })
                .attr("yC", function (d) { return (d.line - env.lineHeight / 2); })
                .attr("id", function (d) { return d.id; })
              .attr("line", function (d) { return d.line; })
               .attr("link", function (d) { return d.parentIds.join(','); })
                ;


            env.group.selectAll(".svgholder")
                .attr("width", function (d) { return env.xt(d.finish) - env.xt(d.start) })            
                .attr("height", env.lineHeight);
 
        

            env.group.selectAll(".rectband")
                .attr("width", function (d) { return env.xt(d.finish) - env.xt(d.start) })
                .attr("height", env.lineHeight)
                .style("opacity", .5) // set the element opacity
                .style("stroke", "black");

        

             env.group.selectAll(".interval")
                .attr("x", 6)
                .attr("y", 9)
                .style("pointer-events", "none")
                .style("fill", "black")
                .attr("font-size", 11)
                .attr("font-family", "Cambria")
                .text(function (d) { return (d.id + ": " + d.description); });


            env.group.selectAll(".lefthand")          
                .attr("idx", function (d) { return d.id; })
                .attr("start", function (d) { return d.start; })
                .attr("height", env.lineHeight)
          
                .attr("width", 2)
                .attr("fill", "#4A235A")
                .attr("fill-opacity", 1)
   

          env.group.selectAll(".righthand")
                .attr("x", function (d) { return env.xt(d.finish) - env.xt(d.start) - 2 })                       
                .attr("idx", function (d) { return d.id; })
                .attr("start", function (d) { return d.start; })
                .attr("height", env.lineHeight)

                .attr("width", 2)
                .attr("fill", "#4A235A")
                .attr("fill-opacity", 1)
                ;        
        
            this.drawLinks(d3, env);
        },
        drawLinks(d3, env) {      
            env.g.selectAll(".rectangle").each(function(d,i) {
                if (d3.select(this).attr("link") !== ''){
                    var linkFrom = d3.select(this);
                    var linkNum = d3.select(this).attr("link");
                    var linkId = d3.select(this).attr("id");
                    var splitLink = linkNum.split(',');

                    splitLink.forEach(function (linkNumInner) {
                    
                        var linkTo = d3.select('.rectangle[id="' + linkNumInner + '"]');

                        console.log(linkTo.data());

                        if (linkTo != null && linkTo._groups != null && linkTo._groups[0][0] !== null){
                            var path = d3.select('.path[pathId="p-' + linkId + '-' + linkNumInner + '"]');
            
                            const linkSource = {
                                x: linkFrom.attr('xC'),
                                y: parseFloat(linkFrom.attr('yC')) + env.lineHeight/2
                            };

                            const linkTarget = {
                                x: parseFloat(parseFloat(linkTo.attr('xC')) + parseFloat(linkTo.attr('width'))),
                                y: parseFloat(linkTo.attr('yC')) + env.lineHeight/2
                            };

                            const link = d3
                                .linkHorizontal()
                                .x(d => d.x)
                                .y(d => d.y)({
                                source: linkSource,
                                target: linkTarget
                            });


                            path
                            .attr('d', link)
                            .attr('marker-end', 'url(#arrow)')
                            .attr('stroke', 'black')
                                .attr('stroke-width', '4')
                            .attr('fill', 'none');
                        }
                    });
                }
            });
        },
        redraw(event, d3, env) {
            console.log( env.svg.select('.x-grid'))
            env.svg.select('.x-grid').call(env.xGrid.scale(env.xt));

            env.color = this.getColor(env)
            env.colorScale = d3.scaleOrdinal(this.colors).domain(env.color)
            env.lineHeight = env.graphH / env.nLines * 0.8;

            if (event) {
                var t = event.transform
                env.xt = t.rescaleX(env.xScale);
            } else {
                env.xt = env.xScale;
            }
    
            d3.selectAll(".rectangle")          
                .data(env.structData)         
                .attr("width", function (d) { return env.xt(d.finish) - env.xt(d.start) })
                .attr("height", env.lineHeight)
                .attr("fill", function (d, i) { return env.colorScale(d.description); })
                .attr("xC", function (d) { return env.xt(d.start); })
                .attr("yC", function (d) { return (d.line - env.lineHeight / 2); })
                .attr("transform", function (d) {return "translate(" + env.xt(d.start) + "," + (d.line - env.lineHeight / 2) + ")";});
            
            d3.selectAll(".svgholder")
                .attr("height", env.lineHeight)
                .attr("width", function (d) { return env.xt(d.finish) - env.xt(d.start) });
            
            d3.selectAll(".rectband")
                .data(env.structData)
                .attr("width", function (d) { return (env.xt(d.finish) - env.xt(d.start)) })
                .attr("height", env.lineHeight)
                .attr("fill", function (d, i) { return env.colorScale(d.description); })
                .attr("x", 0)
                .attr("y", 0);

            d3.selectAll(".interval")
                .attr("x", 6)
                .attr("y", 9)
                .style("pointer-events", "none")
                .style("fill", "black")
                .attr("font-size", 11)
                .attr("font-family", "Cambria")
                .text(function (d) { return (d.id + ": " + d.description); });

            d3.selectAll(".lefthand")           
                .attr("width", 2)
                .attr("height", env.lineHeight)
                .attr("fill", "#4A235A");
            
            d3.selectAll(".righthand")  
                .attr("x", function (d) { return env.xt(d.finish) - env.xt(d.start) - 2 })   
                .attr("width", 2)
                .attr("height", env.lineHeight)
                .attr("fill", "#4A235A");

            this.drawLinks(d3, env);
        }
    }
}
</script>